import React from "react";
import {Radio} from "antd";
import {injectIntl} from "react-intl";
import Constants from "../../../services/Constants";

import './GearboxSelector.css'
import FieldError from "../input/FieldError";

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

class GearboxSelector extends React.Component {

  render() {
    const {intl:{formatMessage}, error, value, onChange, ...attributes} = this.props;

    return (
      <span className={error ? ' error' : ''}>
        <RadioGroup value={value} onChange={onChange} {...attributes}>
          <RadioButton value={Constants.GEARBOX_MANUAL.value}>{formatMessage(Constants.GEARBOX_MANUAL.label)}</RadioButton>
          <RadioButton value={Constants.GEARBOX_AUTOMATIC.value}>{formatMessage(Constants.GEARBOX_AUTOMATIC.label)}</RadioButton>
        </RadioGroup>
        {error && (
          <FieldError error={error}/>
        )}
      </span>
    )
  }
}

export default injectIntl(GearboxSelector);
